import { Observable } from '../observable.js';
import { ActionNode } from './action-node.js';
export class TextToSpeechNode extends ActionNode {
    constructor(id, data, type, implementationFunction = null) {
        super(id, data, type, implementationFunction);
        const audio = new Observable();
        this.data.audio = audio;
    }
}
